export default __webpack_public_path__ + "static/media/user-04.a82825cb.jpg";